import { useEffect, useState } from 'react';

import { revealedBids } from '../helpers/bidVisibility';

// Counts bids that have a populated writer card on screen. Uses the same
// `(bids, now)` calculation BidsList renders from, via the shared helper —
// so this badge is guaranteed to match the visible card count, no drift.
//
// Independent 500 ms ticker (same cadence as BidsList) so the count
// updates a beat after the matching skeleton fades into a card.
export default function useVisibleBidsCount(bids) {
    const [now, setNow] = useState(Date.now());
    useEffect(() => {
        const t = setInterval(() => setNow(Date.now()), 500);
        return () => clearInterval(t);
    }, []);

    return revealedBids(bids, now).length;
}
